var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"poll"},[_c('div',{staticClass:"question",style:({
      backgroundColor: _vm.accentColor,
      color: _vm.textColor
    })},[_vm._v("\n    "+_vm._s(_vm.poll.question)+"\n  ")]),(!_vm.viewerIsLoggedIn)?_c('div',{staticClass:"unauthed"},[_vm._v("\n    You must log in to Twitch to participate in polls.\n  ")]):_c('VoteForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }